import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './roaming.json';
import getCountryListData from './getCountryList.json';

// getCountryList 為遠傳 AEM 的跨域 GET（REACT_APP_FETNET_BASE_URL + /bin/cbu/roaming/getCountryList），
// 非 /eservice/api 信封格式，回傳原始 { result: { continentList } }，不套 mockResponse／withAuthCheck。
// const getCountryList = (req, res, ctx) => {
//   return res(ctx.status(200), ctx.json(getCountryListData));
// };

const getCountryList = (req, res, ctx) => {
  return res(ctx.json(apiResponses['roamingController/getCountryList'].success.default));
};

const initApplyRoamingInfo = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['applyRoamingOfferController/initApplyRoamingInfo'].success.default)));
};

const queryRoamingOfferByCountry = (req, res, ctx) => {
  return res(
    ctx.json(mockResponse(apiResponses['applyRoamingOfferController/queryRoamingOfferByCountry'].success.default))
  );
};

const addRoamingOffer = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['applyRoamingOfferController/addRoamingOffer'].success.default)));
};

const queryCoupon = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['applyRoamingOfferController/queryRoamingCoupon'].success.default)));
};

export const handlers = [

  rest.get(process.env.REACT_APP_FETNET_BASE_URL + '/bin/cbu/roaming/getCountryList', withScenario(getCountryList)),

  rest.post(
    getApiEndpoint('applyRoamingOfferController/initApplyRoamingInfo'),
    withScenario(withAuthCheck(initApplyRoamingInfo))
  ),
  rest.post(
    getApiEndpoint('applyRoamingOfferController/queryRoamingOfferByCountry'),
    withScenario(withAuthCheck(queryRoamingOfferByCountry))
  ),
  rest.post(
    getApiEndpoint('applyRoamingOfferController/addRoamingOffer'),
    withScenario(withAuthCheck(addRoamingOffer))
  ),
  rest.post(getApiEndpoint('applyRoamingOfferController/queryRoamingCoupon'), withScenario(withAuthCheck(queryCoupon))),
];
